import { render } from "./ShowRAB.vue?vue&type=template&id=70ff8fc4&scoped=true"
import script from "./ShowRAB.vue?vue&type=script&lang=js"
export * from "./ShowRAB.vue?vue&type=script&lang=js"

import "./ShowRAB.vue?vue&type=style&index=0&id=70ff8fc4&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70ff8fc4"]])

export default __exports__